export const frontJetTypes = {
  GET_FRONT_SHOP_PRODUCTS: "GET_FRONT_SHOP_PRODUCTS",
  GET_FRONT_SHOP_PRODUCT_TYPE: "GET_FRONT_SHOP_PRODUCT_TYPE",
  GET_FRONT_SHOP_INFO: "GET_FRONT_SHOP_INFO",
  GET_FRONT_SHOP_INFO_NOTICE: "GET_FRONT_SHOP_INFO_NOTICE",
};